import classNames from 'classnames';
import * as React from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { Shape2, Shape2Icon, Shape2Tone } from '../../components/Shape2/Shape2';
import { Bem } from '../../service/Bem/Bem';

import './GalleryItemAudio.css';

interface GalleryItemAudioProps {
    collectionIndex: number;
    removable: boolean;
    name: string;
    durationLabel: string;
    isPlaying?: boolean;

    removeItem: (collectionIndex: number, itemName?: string) => void;
    previewItem: (collectionIndex?: number) => void;
    applyItem: (collectionIndex?: number) => void;
}

const BLOCK = 'gallery-item-audio';

export class GalleryItemAudio extends React.PureComponent<GalleryItemAudioProps> {
    render() {
        const { name, durationLabel } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                <div onClick={this.applyItem} className={Bem.cls(BLOCK, 'name-label')}>
                    {name}
                </div>
                <div className={Bem.cls(BLOCK, 'info')}>
                    <div className={Bem.cls(BLOCK, 'duration')}>{durationLabel}</div>

                    {this.getPlayButton()}
                    {this.getRemoveButton()}
                </div>
            </div>
        );
    }

    private getPlayButton = () => {
        const { isPlaying } = this.props;

        if (isPlaying) {
            return (
                <ButtonDecorator
                    cls={classNames(Bem.cls(BLOCK, 'preview-icon'), Bem.cls(BLOCK, 'control'))}
                    theme={'clear'}
                    onClick={this.previewItem}
                >
                    <Shape2 width={16} height={16} tone={Shape2Tone.dark} icon={Shape2Icon.audioPause} />
                </ButtonDecorator>
            );
        } else {
            return (
                <ButtonDecorator
                    cls={classNames(Bem.cls(BLOCK, 'preview-icon'), Bem.cls(BLOCK, 'control'))}
                    theme={'clear'}
                    onClick={this.previewItem}
                >
                    <Shape2 width={16} height={16} tone={Shape2Tone.dark} icon={Shape2Icon.audioPlay} />
                </ButtonDecorator>
            );
        }
    };

    private getRemoveButton = () => {
        const { removable } = this.props;

        if (!removable) {
            return;
        }

        return (
            <ButtonDecorator
                cls={classNames(Bem.cls(BLOCK, 'audio-remove-icon'), Bem.cls(BLOCK, 'control'))}
                theme={'clear'}
                onClick={this.removeItem}
            >
                <Shape2 width={16} height={16} tone={Shape2Tone.dark} icon={Shape2Icon.trashbin} />
            </ButtonDecorator>
        );
    };

    // для аудио - превью это "начать проигрывать аудио"
    private previewItem = () => {
        if (this.props.isPlaying) {
            this.props.previewItem();
        } else {
            this.props.previewItem(this.props.collectionIndex);
        }
    };

    private removeItem = () => {
        const { name, collectionIndex } = this.props;

        this.props.removeItem(collectionIndex, name);
    };

    private applyItem = () => {
        this.props.applyItem(this.props.collectionIndex);
    };
}
